export default "__VITE_ASSET__DKZSgyDt__"